<template>
  <div v-if="!isError">
    <h4>Результаты голосования</h4>
    <div class="d-flex justify-content-center" v-if="!isLoaded">
      <b-spinner variant="primary" label="Загрузка данных..."></b-spinner>
    </div>
    <div v-else>
      <VotingResultsPolarDiagram :results="results"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VotingResultsPolarDiagram from '@/components/content/events/voting/choice/ResultsPolarDiagram.vue'
import ContentApi from '@/api/content'

export default {
  name: 'VotingResults',
  components: { VotingResultsPolarDiagram },
  props: {
    updater: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      isLoaded: false,
      results: [],
      isError: false
    }
  },
  computed: {
    ...mapGetters({
      content: 'content/getContent'
    }),
  },
  watch: {
    updater() {
      this.updateResults()
    }
  },
  async created() {
    await this.updateResults()
  },
  methods: {
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    }),
    async updateResults() {
      this.isLoaded = false
      if (this.content.contentObject.votingSettings && this.content.contentObject.votingSettings.choice) {
        try {
          const response = await ContentApi.getVoteChoiceEventResults(this.content.contentObject.id)
          this.results = response.data
          this.isLoaded = true
        } catch {
          this.isError = true
          this.pushToasts({
            error: true,
            title: 'Результаты голосования',
            message: 'Произошла ошибка при получении результатов голосования.',
            time: 5
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
